import React from 'react';
import { Box, Button, HStack } from '@chakra-ui/react';
import { ArrowBackIcon, ArrowForwardIcon, CloseIcon } from '@chakra-ui/icons';

interface PresentationNavigationProps {
  isBackDisabled: boolean;
  isNextDisabled: boolean;
  next: () => void;
  back: () => void;
}

const PresentationNavigation = (props: PresentationNavigationProps) => {
  const { isBackDisabled, isNextDisabled, next, back } = props;

  return (
    <Box
      position="fixed"
      right="4"
      bottom="4"
      pt="4"
      pl="4"
      sx={{
        '& .btns': {
          opacity: 0.3,
        },
        '&:hover .btns': {
          opacity: 1,
        },
      }}
    >
      <HStack className="btns">
        <Button
          size="sm"
          colorScheme="blue"
          disabled={isBackDisabled}
          onClick={back}
        >
          <ArrowBackIcon />
        </Button>
        <Button
          size="sm"
          colorScheme="blue"
          onClick={() => window.postMessage('close')}
        >
          <CloseIcon />
        </Button>
        <Button
          size="sm"
          colorScheme="blue"
          disabled={isNextDisabled}
          onClick={next}
        >
          <ArrowForwardIcon />
        </Button>
      </HStack>
    </Box>
  );
};

export default PresentationNavigation;
